import { Box, BoxProps, Link, Text } from "@vinomofo/components";
import { PropsWithChildren } from "react";

import { RelativeSizeImage } from "../relative-size-image";
import { Wine } from "../../types";
import slugify from "slugify";

export interface MixedGridProps extends BoxProps {
  wines: Array<Wine>;
}

export const MixedGrid = ({
  wines,
  ...rest
}: PropsWithChildren<MixedGridProps>): JSX.Element => {
  return (
    <Box maxWidth={["none", "none", "none"]}>
      <Box
        display="grid"
        gridGap={["40px 10px", "40px"]}
        gridTemplateColumns="repeat(auto-fit, minmax(40px, 110px))"
        {...rest}
      >
        {wines.map((wine, i) => {
          return (
            <Box key={i} position="relative">
              <Box overflow="hidden">
                <Link
                  key={i}
                  href={`#notes-${slugify(wine.name, { lower: true })}`}
                >
                  <RelativeSizeImage
                    ratio={1 / 2}
                    image={wine.relativeSizedBottleImage}
                  />
                </Link>
              </Box>
              {wine.quantity && (
                <Box
                  borderRadius="100%"
                  backgroundColor="primary"
                  position="absolute"
                  bottom={-10}
                  left="50%"
                  width="25px"
                  height="25px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    as="span"
                    color="white"
                    fontSize={["10px", "12px"]}
                    lineHeight="none"
                    fontWeight={500}
                  >
                    {wine.quantity}
                  </Text>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
